export default {
    reviewOrder: {
        reviewOrder: "Zkontrolovat objednávku"
    }
}